import { ActionRegistryCategory } from '../../../registry/action/ActionRegistryCategory';
import { ActionRegistryItem } from '../../../registry/action/ActionRegistryItem';
import { runtime } from '../../../classes/runtime/Runtime';
export class ActionsKnowAWord extends ActionRegistryCategory {
    label = 'KnowAWord';
    constructor(parent) {
        super(parent);
        super.init();
    }
    setCurrentUserInput = () => new ActionRegistryItem({
        label: 'Set current User Input',
        action: ({ wordTask, keyboardEvent }) => {
            if (!wordTask)
                return;
            wordTask.wordTaskInput.inputValue = keyboardEvent.inputValue;
        },
    });
    setInputFocus = () => new ActionRegistryItem({
        label: 'Set Input Focus',
        action: ({ app, wordTask }) => {
            if (runtime.isServerRuntime)
                return;
            if (!wordTask)
                return;
            if (app.appInfo.isAppInEditBuild)
                return;
            wordTask.wordTaskForm.focusInputField();
        },
    });
    setCursorToPos0ForTextMasks = () => new ActionRegistryItem({
        action: ({ wordTask }) => {
            if (wordTask.wordTaskInput.inputValueHidden.length > 0)
                return;
            const inputElement = wordTask.ownAspect.input.aspectMount.domElement;
            if (inputElement) {
                inputElement.focus();
                inputElement.setSelectionRange(0, 0);
            }
        }
    });
    ignoreKeyPress = () => new ActionRegistryItem({
        label: 'IgnoreKeypress',
        action: ({ e }) => {
            e.preventDefault();
        },
    });
}
